'use client'

import { useEffect } from 'react'
import { usePathname } from 'next/navigation'
import { initializeTracking, trackPageVisit } from '@/lib/user-tracking'
import { initializeAdvancedTracking, trackPageNavigation, cleanupTracking } from '@/lib/advanced-tracking'

export function TrackingProvider({ children }: { children: React.ReactNode }) {
  const pathname = usePathname()

  useEffect(() => {
    // Initialize both tracking systems
    initializeTracking()
    initializeAdvancedTracking()
    
    return () => {
      cleanupTracking()
    }
  }, [])

  useEffect(() => {
    // Track page visits on route changes
    trackPageVisit()
    trackPageNavigation()
  }, [pathname])

  return <>{children}</>
}